import React from "react";
import { Card, Row, Col } from "react-bootstrap";

export function CategoryCard({
  title,
  iconSrc,
  iconAlt = "",
  iconSize = 44,
  tileColor = "white",
  href,
  onClick,
}: {
  title: string;
  iconSrc: string;
  iconAlt?: string;
  iconSize?: number;
  tileColor?: string;
  href?: string;
  onClick?: () => void;
}) {
  const content = (
    <Card
      className="category-card h-100 d-flex"
      style={{
        borderRadius: 16,
        boxShadow: "0 0 0 1px rgba(0,0,0,0.08), 0 2px 10px rgba(0,0,0,0.04)",
        height: "100%",
        minWidth: 220,
        minHeight: 220,
      }}
    >
      <Card.Body className="d-flex flex-column align-items-center justify-content-center p-4 p-lg-5">
        <div
          className="icon-tile d-grid place-items-center mb-3"
          style={{
            width: 84,
            height: 84,
            borderRadius: 20,
            background: tileColor,
            flexShrink: 0,
          }}
        >
          <img
            src={iconSrc}
            alt={iconAlt || title}
            width={"100%"}
            height={"100%"}
            style={{ objectFit: "contain" }}
          />
        </div>
        <Card.Title
          as="h5"
          className="text-center mb-0 fw-semibold"
          style={{ color: "#111827" }}
        >
          {title}
        </Card.Title>
      </Card.Body>
    </Card>
  );

  if (href) {
    return (
      <a
        href={href}
        className="text-decoration-none d-block h-100"
        onClick={onClick}
        aria-label={title}
      >
        {content}
      </a>
    );
  }
  return (
    <div
      role="button"
      onClick={onClick}
      className="text-decoration-none d-block h-100"
    >
      {content}
    </div>
  );
}

export default function CategoryGrid({
  items,
}: {
  items: Array<{
    title: string;
    iconSrc: string;
    iconAlt?: string;
    tileColor?: string;
    href?: string;
    onClick?: () => void;
  }>;
}) {
  return (
    <Row className="g-4 g-md-4 g-lg-4">
      {items.map((it, idx) => (
        <Col
          key={idx}
          xs={12}
          sm={6}
          lg={3}
          className="d-flex justify-content-center"
        >
          <CategoryCard
            title={it.title}
            iconSrc={it.iconSrc}
            iconAlt={it.iconAlt}
            tileColor={it.tileColor}
            href={it.href}
            onClick={it.onClick}
          />
        </Col>
      ))}
    </Row>
  );
}
